import React from 'react';
import ZoomButton from '../ZoomButton';

export default class ImperativeZoomButton extends React.Component {
  constructor(props) {
    super(props);

    const {
      disableZoomIn = false,
      disableZoomOut = false,
    } = props;

    this.state = {
      disabledZoomIn: disableZoomIn,
      disabledZoomOut: disableZoomOut,
    };
  }

  setDisabledZoomIn(disabled) {
    this.setState({
      disabledZoomIn: disabled,
    });
  }

  setDisabledZoomOut(disabled) {
    this.setState({
      disabledZoomOut: disabled,
    });
  }

  /**
   * accesible from outside through ref
   */
  disableZoomIn() {
    this.setDisabledZoomIn(true);
  }

  /**
   * accesible from outside through ref
   */
  enableZoomIn() {
    this.setDisabledZoomIn(false);
  }

  /**
   * accessible from outside through ref
   */
  enableZoomOut() {
    this.setDisabledZoomOut(false);
  }

  /**
   * accesible from outside through ref
   */
  disableZoomOut() {
    this.setDisabledZoomOut(true);
  }

  render() {
    // styles
    const { style, theme } = this.props;
    // callbacks
    const { onZoomIn, onZoomOut } = this.props;

    // current state
    const { disabledZoomIn, disabledZoomOut } = this.state;

    return (
      <ZoomButton
        style={style}
        theme={theme}
        onZoomIn={onZoomIn}
        onZoomOut={onZoomOut}
        disableZoomIn={disabledZoomIn}
        disableZoomOut={disabledZoomOut}
      />
    );
  }
}
